import React from 'react'
import { BaseFormNode } from './baseFormNode'
import InputComponent from '../components/input'

export class InputNode extends BaseFormNode {
  static getType() { return 'input' }

  static clone(node) {
    return new InputNode({ ...node.__props }, node.__key)
  }

  static importJSON(serializedNode) {
    return new InputNode(serializedNode.__props)
  }

  exportJSON() {
    return { type: 'input', version: 1, __props: this.__props }
  }

  createDOM() {
    const span = document.createElement('span')
    span.style.display = 'inline'
    span.style.verticalAlign = 'baseline'
    return span
  }

  updateDOM() { return false }

  decorate(editor) {
    return (
      <InputComponent
        value={this.__props.value}
        onChange={val => this.onChange(editor, val)}
      />
    )
  }
}
